export default "__VITE_ASSET__94891981__"